import type { ReactElement, ReactNode } from "react"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import FlexContainerOrg from "@onestore/hel/dist/components/organisms/FlexContainerOrg"
import useBreakpoint from "@onestore/hel/dist/hooks/useBreakpoint"
import _t from "@core/i18n"
import { Button } from "@ionos-web-design-system/react"
import Tooltip from "~/components/Tooltip"
import { md } from "~/lib/i18n"

type SubmitFieldBottomTextsProps = {
  onNextStepClick?: { (): void }
  nextStep?: boolean | null
  hideText?: boolean
  hideTextPlaceholder?: ReactNode
}

export default function SubmitFieldBottomTexts({
  onNextStepClick,
  nextStep,
  hideText,
  hideTextPlaceholder,
}: SubmitFieldBottomTextsProps): ReactElement<SubmitFieldBottomTextsProps> {
  const isMediumUp = useBreakpoint("medium")

  return (
    <FlexContainerOrg
      alignItems="center"
      justifyContent="space-between"
      direction={isMediumUp ? undefined : "column"}
    >
      {!hideText ? (
        <Tooltip
          labelTypography="tiny2"
          iconSize="small"
          labelText={_t("preBasket.searchSortInfoLabel")}
        >
          <TextAtm typography="nano1">
            {md("preBasket.searchSortInfoTooltip", undefined, undefined, true)}
          </TextAtm>
        </Tooltip>
      ) : (
        hideTextPlaceholder
      )}

      {nextStep ? (
        <Button
          size="medium"
          variant="secondary"
          concept="monochrome"
          onClick={onNextStepClick}
          title={_t("preBasket.nextStepWithoutDomain")}
          data-test-id="without_domain_button"
        >
          {_t("preBasket.nextStepWithoutDomain")}
        </Button>
      ) : null}
    </FlexContainerOrg>
  )
}
